import api from '@/api'

const DEFAULT_NAME = 'download.pdf'

// Content-Disposition is not consistently quoted or terminated across our endpoints, and a
// header we cannot parse is not a reason to fail the download — fall back to a usable name.
export function filenameFromDisposition(header, fallback = DEFAULT_NAME) {
    if (!header) return fallback
    const match = header.match(/filename\s*=\s*"?([^";]+)"?/i)
    if (!match || !match[1]) return fallback
    return match[1].trim() || fallback
}

/**
 * Downloads url (relative to the api baseURL) as a file. Resolves false when the server
 * answered 204 — nothing to download — and true when a file was delivered.
 *
 * Pass { filename } when the caller, not the response, decides the name: the research export
 * names itself after the selected period, and the server sends no usable header for it.
 *
 * Pass { silent: true } when the caller shows its own error message: the request uses
 * responseType 'blob', so a failure response body is a Blob, and the global interceptor
 * would render it as "[object Blob]" alongside the caller's specific message. Defaults to
 * falsy so callers with no error handling of their own (the existing print pages) keep
 * getting the global error snackbar.
 */
export async function downloadFile(url, { filename, silent } = {}) {
    const res = await api.client.get(url, { responseType: 'blob', silent })
    if (res.status === 204) return false

    const blob = new Blob([res.data], { type: res.data.type })
    const objectUrl = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = objectUrl
    link.download = filename || filenameFromDisposition(res.headers && res.headers['content-disposition'])
    document.body.appendChild(link)
    link.click()
    link.remove()
    // The inline copies this replaces never revoked, leaking one blob per print for the life
    // of the page.
    URL.revokeObjectURL(objectUrl)
    return true
}
